import { render, staticRenderFns } from "./BCXAvatar.vue?vue&type=template&id=c351241c&scoped=true"
import script from "./BCXAvatar.vue?vue&type=script&lang=ts"
export * from "./BCXAvatar.vue?vue&type=script&lang=ts"
import style0 from "./BCXAvatar.vue?vue&type=style&index=0&id=c351241c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c351241c",
  null
  
)

export default component.exports